import React, { Component } from 'react'

import style from './style.css'

class FlexAlign extends Component {
  render() {
    return (
        <div className={style.flexAlign} style={{
          alignItems: this.props.align || 'center',
          ...this.props.style
        }}>
            {this.props.children}
        </div>  
    )
  }
}

export default FlexAlign


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/FlexAlign/index.js